import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeProductWrite } from './serialize';
import { omitTopLevelId } from '#/api/adapters/patchBody';

/**
 * 更新產品（partial PATCH）。
 * `PATCH /crm/product/{id}`；必帶 `updatedAt`。
 * 有傳 `materials`／`extraItems`＝整包替換（replace-all）；省略＝不改該子表。
 * **不送** status（啟停走 activate／deactivate）。
 * materials 只送 `mtrId`（不送 materialId alias）。
 *
 * @param {string} id
 * @param {object} payload — camelCase（含 updatedAt）
 */
export async function updateProduct(id, payload) {
  const { data: raw } = await request.patch(
    `/crm/product/${id}`,
    serializeProductWrite(omitTopLevelId(payload)),
  );
  return parseVer4DetailResponse(raw);
}
